import { io } from "socket.io-client";
import { backendAddress } from "../config";
import { gameActiveSetter, inviteFailedSetter, setOnlineUsers, waitingForPlayerSetter } from "../DataStore/DataStore";
import { gameEnemyDisconnectedMsgSetter, gameStateSetter } from "../GamePage/GamePage";

var s: any;

export async function initSocket(setOnlineCount: any) {

  s = io(backendAddress);

  const key = sessionStorage.getItem("session_id");

  if (key !== null) {
    s.emit("session-link", key);
  }

  s.on("reconnect", () => {
    if (key !== null) {
      s.emit("session-link", key);
    }
  });

  s.on("online-count", (data: any) => {
    setOnlineCount(data);
  });

  s.on("online-user-data", (data: any) => {
    setOnlineUsers(data);
  });

  s.on("game-state-update", (data: any) => {
    if (gameStateSetter === undefined) return;
    gameStateSetter(data);
    gameActiveSetter(true);
    waitingForPlayerSetter(false);
  });

  s.on("game-enemy-disconnect-event", (data: any) => {
    console.log("game-enemy-disconnect-event:"); // TODO: remove DEBUG
    console.log(data); // TODO: remove DEBUG
    if (gameEnemyDisconnectedMsgSetter !== undefined) gameEnemyDisconnectedMsgSetter(data.msg);
  });

  s.on("game-invite-failed-event", (data: any) => {
    console.log("game-invite-failed-event:"); // TODO: remove DEBUG
    console.log(data); // TODO: remove DEBUG
    if (inviteFailedSetter !== undefined) inviteFailedSetter(true);
  });

}

export async function sendSocket(topic: string, data: any) {
  if (s === undefined) return;
  s.emit(topic, data);
}
